import { IGeoLabel } from '../../types';
import styles from './GeoBlock.css';
import { GeoLabel } from './GeoLabel';
import { FC } from 'react';

interface IGeoBlockProps {
  geoLabels: IGeoLabel[];
}

export const GeoBlock: FC<IGeoBlockProps> = ({ geoLabels }) => {
  return (
    <div className={styles['labels']}>
      {geoLabels.map((label, index) => {
        const item = <GeoLabel key={`offer-card-geo-${label.url}`} {...label} />;

        return [index > 0 && ', ', item];
      })}
    </div>
  );
};
